/** Opening `MediaInput`s (URL or Blob) with mediabunny, and small shared helpers. */
import { ALL_FORMATS, BlobSource, Input, UrlSource } from 'mediabunny';
import type { MediaInput } from '@ve/engine';

export function openInput(source: MediaInput): Input {
  return new Input({
    source: typeof source === 'string' ? new UrlSource(source) : new BlobSource(source),
    formats: ALL_FORMATS,
  });
}

/** Fetches a URL input as a Blob (Blobs are returned as-is). */
export async function toBlob(source: MediaInput, signal?: AbortSignal): Promise<Blob> {
  if (typeof source !== 'string') return source;
  const res = await fetch(source, { signal });
  if (!res.ok) throw new Error(`Could not read media (${res.status})`);
  return res.blob();
}

export function throwIfAborted(signal: AbortSignal): void {
  if (signal.aborted)
    throw signal.reason instanceof Error ? signal.reason : new DOMException('Aborted', 'AbortError');
}

export function createCanvas(width: number, height: number): OffscreenCanvas {
  return new OffscreenCanvas(Math.max(1, Math.round(width)), Math.max(1, Math.round(height)));
}

export async function canvasToJpeg(canvas: OffscreenCanvas, quality = 0.82): Promise<Blob> {
  return canvas.convertToBlob({ type: 'image/jpeg', quality });
}
